/* import __COLOCATED_TEMPLATE__ from './advanced.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsNoteDiagnosisTreatmentPlanAdvanced extends Component {}
